/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import ConfirmAlertWithAmount from 'modules/common/components/ConfirmAlertWithAmount';
import SeniorCitizenContent from './SeniorCitizenContent';


import * as actions from '../action';
import * as c from '../constant';

const form = {
  keyword: '',
  status: '',
  module_type: 'SENIOR',
};


function SeniorCitizenContainer({
  history,
  match,
  isLoading,

  showSeniorCitizen,
  seniorCitizenList,
  getSeniorCitizenList,
  seniorCitizenListPager,

  approveTransaction,
  rejectTransaction,

  seniorCitizenInfo,
  showSeniorCitizentList,
}) {
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {

    getSeniorCitizenList()
  };

  const param = {
    module_type: 'EHELP',
    q: formData.keyword,
    sort_by: 'asc',
    status: filter.status,
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      status: e.value,
    });
    getSeniorCitizenList({ ...filter, status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getSeniorCitizenList({ module_type: 'SENIOR', q: formData.keyword });
    } else {
      getSeniorCitizenList({ module_type: 'SENIOR' });
    }
  }, [debouncedSearchTerm]);

  // handle Approve button
  const handleApprove = (data) => (e) => {
    e.preventDefault();

    // const args = {
    //   status: 'APPROVED',
    //   amount: '12000',
    //   remarks: 'random test 3',
    // }
    // approveTransaction(
    //   _.get(data, 'id'),
    //   args,
    //   () => {
    //     showSeniorCitizentList(_.get(data, 'id'));
    //     console.log('seniorCitizenInfo', seniorCitizenInfo)
    //   }
    // );

    ConfirmAlertWithAmount(
      'Are you sure, you want to Approve this application?',
      (remarks, amount) => {

        const args = {
          status: 'APPROVED',
          remarks,
          amount,
          module_type: 'SENIOR',
        }
        approveTransaction(
          _.get(data, 'id'),
          args,
          () => {
            showSeniorCitizentList(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // const aprove = (data) => (e) => {
  //   e.preventDefault();
  //   const args = {
  //     status: 'APPROVED',
  //     amount: '5000.00',
  //     remarks: 'testing'
  //     // module_type: 'SENIOR',
  //   }

  //   approveTransaction(
  //     _.get(data, 'id'),
  //     args,
  //     () => {
  //       showSeniorCitizentList(_.get(data, 'id'));
  //       console.log('approveTransaction', approveTransaction(_.get(data, 'id'), args, () => { showSeniorCitizentList(_.get(data, 'id'))}))
  //     }
  //   );
  // }



  // handle reject button
  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        rejectTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'REJECTED'
          },
          () => {
            showSeniorCitizen(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName=""
            getData={getSeniorCitizenList}
            setParams={param}
            setKeyword={handleOnChange}

            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'status')
            )}
            status={_.get(filter, 'status') || ''}
            keyword={_.get(formData, 'keyword') || ''}

            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            // listName="Transaction"
            label="Citizen Lists"
            // LEFT SECTION
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="senior-citizen-list">
                  {`${_.get(item, 'attributes.first_name')} ${_.get(item, 'attributes.middle_name')} ${_.get(item, 'attributes.last_name')}` || '- -'}
                </div>
                <h4 className="mt-1 mb-0 senior-citizen-list-numbers">
                  {' '}{_.get(item, 'attributes.contact_number')}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            // statusFilter
            selected={params.id}
            data={seniorCitizenList}
            dataPager={seniorCitizenListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            // RIGHT SECTION
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <SeniorCitizenContent
                        UpdateData={UpdateData}
                        testingApprove={handleApprove}

                        onApprove={handleApprove}
                        onReject={handleReject}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.id && seniorCitizenList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(seniorCitizenList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

SeniorCitizenContainer.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,

  seniorCitizenList: PropTypes.instanceOf(Object).isRequired,
  getSeniorCitizenList: PropTypes.instanceOf(Function).isRequired,
  seniorCitizenListPager: PropTypes.instanceOf(Object).isRequired,
  showSeniorCitizen: PropTypes.instanceOf(Function).isRequired,

  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,

  seniorCitizenInfo: PropTypes.instanceOf(Object).isRequired,
  showSeniorCitizentList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.GET_SENIOR_CITIZEN) > -1,

  seniorCitizenList: _.get(api, `${c.GET_SENIOR_CITIZEN}.list`) || [],
  seniorCitizenListPager: _.get(api, `${c.GET_SENIOR_CITIZEN}.pager`) || [],

  // individual info
  seniorCitizenInfo: _.get(api, `${c.SHOW_SENIOR_CITIZEN}.item`) || {},
  showSeniorCitizentList: PropTypes.instanceOf(Function).isRequired,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SeniorCitizenContainer);